import { platform } from "@shared/platform-api/requests"
import { FleetChangeInput } from "@shared/platform-api/generated"

export type ChangeFleetModernInput = {
  policyId: string
  changes: Array<FleetChangeInput>
  requestedAccessLevel: "standard" | "elevated"
}

export const changeFleetModern = async (
  { policyId, changes, requestedAccessLevel }: ChangeFleetModernInput,
  getToken: () => Promise<string>
) =>
  platform(getToken).fleets.changeFleet({
    id: policyId,
    requestBody: {
      requestedAccessLevel,
      changes,
    },
  })
